import React, { useState } from 'react'
import { TableCell } from '@mui/material';

import { SupplierPerformanceReportResponse } from '@/main/models/response';

import * as S from './styles';
import { userIsSupplier } from '@/main/services/utilsUser';

interface IRowDataSupplierPerformanceProps {
  itemRow: SupplierPerformanceReportResponse;
}

function RowDataSupplierPerformance({
  itemRow,
}: IRowDataSupplierPerformanceProps) {

  return (
    <S.Container $isSizeLong $notClickable>
      <TableCell><S.CustomColumn title={itemRow.supplierCompanyName}>{itemRow.supplierCompanyName}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={itemRow.supplierTradeName}>{itemRow.supplierTradeName}</S.CustomColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.totalPartsSent)}>{itemRow.totalPartsSent}</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.totalPartsAnswered)}>{itemRow.totalPartsAnswered}</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.partsAnsweredManually)}>{itemRow.partsAnsweredManually}</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.partsAnsweredAutomatically)}>{itemRow.partsAnsweredAutomatically}</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.partsAssigned)}>{itemRow.partsAssigned}</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={String(itemRow.partsCanceledAndReturned)}>{itemRow.partsCanceledAndReturned}</S.CenterColumn></TableCell>
      {!userIsSupplier() && <TableCell><S.CenterColumn title={String(itemRow.partsTransfered)}>{itemRow.partsTransfered}</S.CenterColumn></TableCell>}
      <TableCell><S.CenterColumn title={`${itemRow.answeredPorcentage}%`}>{itemRow.answeredPorcentage}%</S.CenterColumn></TableCell>
      <TableCell><S.CenterColumn title={`${itemRow.assignedPorcentage}%`}>{itemRow.assignedPorcentage}%</S.CenterColumn></TableCell>
    </S.Container>
  );
}

export default RowDataSupplierPerformance